import { selectTitleSchema } from '@/redux/selectors/profileSelectors';
import { useMemo } from 'react';
import { FormValues } from '../../redux/slices/slice_types';
import { useAppSelector } from '@/redux/hooks';

const useProfile = (values: FormValues = { jobs: [] }) => {
  const profileData = values.jobs?.[0]?.profile?.data || {};
  const titleSchema = useAppSelector((state) => selectTitleSchema(state, profileData?.workflow));
  const templateInputs = profileData?.template_inputs || {};
  const isVersionBased = !profileData.workflow_type || ['version_based', 'package', 'version_based_bundle'].indexOf(profileData.workflow_type) !== -1;
  const isBulkBased = profileData.workflow_type === 'bulk';

  const getKeyByFormat = (format: string) => {
    if (titleSchema && titleSchema.properties) {
      return Object.keys(titleSchema.properties).find((key) => titleSchema.properties[key].format === format);
    }
  };

  const versionOutputKey = useMemo(() => getKeyByFormat('VersionOutput'), [titleSchema]);
  const programOutputVersionKey = useMemo(() => getKeyByFormat('ProgramVersionOutput'), [titleSchema]);
  const outputVersionKey = versionOutputKey || programOutputVersionKey;

  return { titleSchema, templateInputs, isVersionBased, isBulkBased, outputVersionKey };
};

export default useProfile;
